import { render } from "./SelectMultipleWorkstationModal.vue?vue&type=template&id=c9283c1e&ts=true"
import script from "./SelectMultipleWorkstationModal.vue?vue&type=script&lang=ts"
export * from "./SelectMultipleWorkstationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__